<!--
功能名称:tabbar底部导航
开发人:梁高权
创建时间:2021/03/12
最后修改时间:2021/03/12
-->

<template>
  <div class="tabbar-wrap">
    <van-tabbar v-model="active" :placeholder="true" active-color="#691BFF" inactive-color="#999999">
       <van-tabbar-item :name="item.link" v-for="(item,index) in technician.renderBarList" :key="index" :to="item.link" :badge="item.badge">
         <span>{{item.name}}</span>
         <template #icon="props">
           <img :src="props.active ? item.active : item.inactive" />
         </template>
       </van-tabbar-item>
     </van-tabbar>
     <div @click="home">
         <div class="home">
            <img src="@/assets/images/homeButton.png">
            <span>首页</span>
         </div>
     </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'tabbar',
  data () {
    return {
      active:this.$route.name
    }
  },
  computed: {...mapState(['technician'])},
  watch: {},
  created () {},
  mounted () {},
  methods:{
    home(){
      location.href=location.protocol+'//'+location.host
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/.van-tabbar__placeholder{
    height: 98px !important;
    .van-tabbar{
      height: 98px;
      .van-tabbar-item__icon{
        margin-bottom: 8px;
        img{height: 40px}
      }
      .van-tabbar-item__text{font-size: 24px;}
    }
  }
  .home{
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
    position:fixed;
    right: 20px;
    bottom: 300px;
    width:72px;
    height:72px;
    border-radius:50%;
    background: #FF7C4A;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    img{width: 27px;height: 27px}
    span{font-size: 18px;}
  }
</style>
